import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, Define, SettingState,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import * as tios from './tios';
import * as zephyr from './zephyr';

export default class Bluetooth extends BaseFeature {
    constructor() {
        super();
        this.name = 'Bluetooth Peripheral';
        this.id = 'bt';
        this.icon = 'FaBluetoothB';
        this.requirements = [['tios', 'zephyr'], 'bluetooth'];
        this.capabilities = ['bluetooth'];
        const settings = [
            {
                id: 'ENABLED',
                name: 'Bluetooth Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'DEVICENAME',
                name: 'Advertising Name',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: 'MyBTDevice',
                setting: {
                    SETTINGID: 'BTNAME',
                    NAME: 'Bluetooth Advertising Name',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 1,
                    MAX: 32,
                    DEFAULT: 'MyBTDevice',
                },
                UIControl: {
                    CONTROL: 'EDIT',
                },
            },
            {
                id: 'EMULATION',
                name: 'Emulation Mode',
                settingType: SettingType.OPTION,
                required: true,
                default: 'PL_WLN_BT_EMULATION_MODE_MICROCHIP',
                options: [
                    {
                        name: 'Microchip',
                        value: 'PL_WLN_BT_EMULATION_MODE_MICROCHIP',
                    },
                    {
                        name: 'TI(Texas Instruments)',
                        value: 'PL_WLN_BT_EMULATION_MODE_TI',
                    },
                    {
                        name: 'Nordic',
                        value: 'PL_WLN_BT_EMULATION_MODE_NORDIC',
                    },
                ],
            },
            {
                id: 'TXBUF',
                name: 'TX Buffer Pages',
                settingType: SettingType.BUFFER,
                required: true,
                default: '1',
            },
            {
                id: 'RXBUF',
                name: 'RX Buffer Pages',
                settingType: SettingType.BUFFER,
                required: true,
                default: '1',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDependencies() {
        const { project } = this;
        if (project.runtime === 'tios') {
            const dependencies = [
                'wireless_module',
            ];
            if (project.device.platform !== 'WM2000') {
                return dependencies;
            }
        } else if (project.runtime === 'zephyr') {
            const dependencies = [
                'stg',
            ];
            return dependencies;
        }
        return [];
    }

    getState(settingId: string): SettingState {
        if (settingId !== 'ENABLED' && this.getSettingValue('ENABLED').toString() === '0') {
            return SettingState.DISABLED;
        }
        switch (settingId) {
            case 'ENABLED':
                return SettingState.ENABLED;
            case 'EMULATION':
                if (this.project.runtime === 'tios') {
                    return SettingState.ENABLED;
                }
                return SettingState.HIDDEN;
            default:
                return SettingState.ENABLED;
        }
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'tios':
                return tios.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return [];
        }
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/object_bt';
    }
}
